export default {"src":"/_next/static/media/favicon.8cc4d680.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};